import type { ChangeEvent } from 'react';

import { forwardRef } from 'react';

import { type MaskFieldProps, MaskField } from './MaskField';

const SSN_MASK = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

interface SsnFieldProps extends Omit<MaskFieldProps, 'mask' | 'onChange'> {
  onChange?: (value: string) => void;
}

export const SsnField = forwardRef<HTMLInputElement, SsnFieldProps>((props, ref) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(e.target.value);
  };

  return (
    <MaskField mask={SSN_MASK} inputMode="numeric" autoComplete="off" {...props} ref={ref} onChange={handleChange} />
  );
});
